export default __webpack_public_path__ + "static/Card14-a698ce7ec14ab10b034308ac9defbff8.png";